export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const CREATE_CLIENT = 'CREATE_CLIENT';
export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_STATUS = 'UPDATE_CLIENT_STATUS';
export const UPDATE_CLIENT_STATUS_REQUEST = 'UPDATE_CLIENT_STATUS';
